export const TOKEN_KEY = 'token';
export const TOKENIZE_URL_START_WITH = ['/v1/'];